var _path, _path2, _path3, _path4, _path5, _path6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFlagIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.314 8.05H1.787A1.523 1.523 0 01.264 6.527V1.523C.264.683.946 0 1.787 0h6.527c.842 0 1.524.682 1.524 1.523v5.004c0 .841-.682 1.523-1.524 1.523zM8.314 52H1.787a1.523 1.523 0 01-1.523-1.523V35.682c0-.841.682-1.523 1.523-1.523h6.527c.842 0 1.524.682 1.524 1.523v14.795c0 .84-.682 1.523-1.524 1.523z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.838 6.527V1.523C9.838.683 9.156 0 8.314 0H5.051v8.05h3.263c.842 0 1.524-.682 1.524-1.523zM9.838 50.477V35.682c0-.841-.682-1.523-1.524-1.523H5.051V52h3.263c.842 0 1.524-.682 1.524-1.523z",
    fill: "#D9D9D9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.184 35.682H.264v-9.574c0-.841.682-1.523 1.523-1.523h6.527v-6.96H1.787A1.523 1.523 0 01.264 16.1V6.527h43.92c.401 0 .795.144 1.084.424.492.476.6 1.196.308 1.78l-6.187 12.374 6.187 12.373a1.525 1.525 0 01-.308 1.78c-.289.28-.683.424-1.084.424z",
    fill: "#ADC6FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.314 24.585H1.787c-.841 0-1.523.682-1.523 1.523v9.574h43.92c.401 0 .795-.144 1.084-.423.492-.476.6-1.197.308-1.781l-6.187-12.373H8.314v3.48z",
    fill: "#85A5FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M.264 26.108V16.101h8.05c.842 0 1.524.682 1.524 1.523v6.961c0 .841-.682 1.523-1.524 1.523H.264z",
    fill: "#F0F0F0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.838 24.585v-6.96c0-.842-.682-1.524-1.524-1.524H5.051v10.007h3.263c.842 0 1.524-.682 1.524-1.523z",
    fill: "#D9D9D9"
  })));
}

export default __webpack_public_path__ + "./fonts/flag-icon.3b13f4ee1c313854d3c9561e55a2b52e.svg";
export { SvgFlagIcon as ReactComponent };